<template>
    <div>
        <div class="t-docs">
            <div class="t-docs__container">
                <div class="t-docs__item">
                    <div class="t-docs__info">
                        <div class="t-docs__name" style="font-weight: 600; margin-bottom: 0;">                     
                            {{name}}
                        </div>
                        <div class="t-docs__cakt">
                            {{cakt}}
                        </div>
                        <button @click="toggleData" class="docs-search-form__button" :class="buttonClass">{{ buttonText }}</button>
                        <div v-if="showData">
                            <div v-for="item in listSubCakt" :key="item.id">
                                <div v-if="item.type === 'search'">
                                    <SearchResults 
                                        :name="item.name"
                                        :cakt="item.cakt"
                                        :link="item.link"
                                    />
                                </div>
                                <div v-else-if="item.type === 'download'">
                                    <DownloadResults 
                                        :fullname="item.fullname"
                                        :cakt="item.cakt"
                                        :link="item.link"
                                        :type="item.type"
                                    />
                                </div>
                                <div v-else>
                                    <Error />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import DownloadResults from '@/components/Results/download-result.vue'
import SearchResults from '@/components/Results/search-result.vue'
import Error from '@/components/Errors/Error.vue'
export default {
    name: 'SearchResults',
    components: {
        DownloadResults, SearchResults,Error
    },
    props: {
        name: String,
        cakt: String,
        link: String
    },
    data() {
        return {
            listSubCakt: '',
            show: false,
            isOpen: false,
            buttonText: 'Открыть',
            url: this.link,
            showData: false,
            buttonClass: ''
        }
    },
    methods: {
        toggleData() {
            if (this.showData) {
                this.showData = false;
                this.buttonText = 'Открыть';
                this.buttonClass = ''
            } else {
                axios.get(this.url).then(response => {
                    this.listSubCakt = response.data;
                    this.showData = true;
                    this.buttonText = 'Закрыть';
                    this.buttonClass = 'docs-search-form__button_active'
                });
            }
        }
    },
    created() {
        axios.get(this.url).then(response => {
            this.listSubCakt = response.data;
        });
    },
    updated() {
        axios.get(this.link).then(response => {
            this.listSubCakt = response.data;
        });
    },
    watch: {
        link() {
            this.showData = false;
            this.buttonText = 'Открыть';
            this.buttonClass = '';
            //console.log('Изменилась ссылка')
        }
    }
}
</script>


<style lang="sass" scoped>
.docs-search-form__button
    background-color: #ffffff
    color: #5a72b0
    border: 1px solid #5a72b0
    cursor: pointer
    transition: 0.5s
    font-size: 12px
    font-family: inherit
    margin-top: 10px
    &:hover
       background-color: #012786a6
       color: #fff
    &_active
       background-color: #012786a6
       color: #fff
</style>